// Copyright (c) 2021 WiseTime. All rights reserved.

import React from "react"
import styled, { keyframes } from "styled-components/macro"

const frame0 = keyframes`

  0% {
    opacity: 0.1;
  }

  0.01% {
    opacity: 0.1;
  }

  0.02% {
    opacity: 1;
  }

  60.01% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.1;
  }
`

const frame1 = keyframes`

  0% {
    opacity: 0.1;
  }

  9.10091% {
    opacity: 0.1;
  }

  9.11091% {
    opacity: 1;
  }

  69.1009% {
    opacity: 0.1;
  }

  100% {
    opacity: 0.1;
  }
`

const frame2 = keyframes`

  0% {
    opacity: 0.1;
  }
  18.1918% {
    opacity: 0.1;
  }
  18.2018% {
    opacity: 1;
  }
  78.1918% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.1;
  }
`

const frame3 = keyframes`

  0% {
    opacity: 0.1;
  }
  27.2827% {
    opacity: 0.1;
  }
  27.2927% {
    opacity: 1;
  }
  87.2827% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.1;
  }
`

const frame4 = keyframes`
  0% {
    opacity: 0.1;
  }
  36.3736% {
    opacity: 0.1;
  }
  36.3836% {
    opacity: 1;
  }
  96.3736% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.1;
  }
`

const frame5 = keyframes`
  0% {
    opacity: 0.181968;
  }
  45.4645% {
    opacity: 0.1;
  }
  45.4745% {
    opacity: 1;
  }
  5.46455% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.181968;
  }
`

const frame6 = keyframes`
  0% {
    opacity: 0.318332;
  }
  54.5555% {
    opacity: 0.1;
  }
  54.5655% {
    opacity: 1;
  }
  14.5555% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.318332;
  }
`

const frame7 = keyframes`
  0% {
    opacity: 0.454695;
  }
  63.6464% {
    opacity: 0.1;
  }
  63.6564% {
    opacity: 1;
  }
  23.6464% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.454695;
  }
`

const frame8 = keyframes`
  0% {
    opacity: 0.591059;
  }
  72.7373% {
    opacity: 0.1;
  }
  72.7473% {
    opacity: 1;
  }
  32.7373% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.591059;
  }
`

const frame9 = keyframes`
  0% {
    opacity: 0.727423;
  }
  81.8282% {
    opacity: 0.1;
  }
  81.8382% {
    opacity: 1;
  }
  41.8282% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.727423;
  }
`

const frame10 = keyframes`
  0% {
    opacity: 0.863786;
  }
  90.9191% {
    opacity: 0.1;
  }
  90.9291% {
    opacity: 1;
  }
  50.9191% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.863786;
  }
`

const Wrapper = styled.div`
`

const SpinnerHand = styled.div`
  position: absolute;
  top: -1px;
  opacity: 0.1;

  > div {
    position: absolute;
    width: 4px;
    height: 1px;
    background: black;
    box-shadow: rgba(0, 0, 0, 0.0980392) 0px 0px 1px;
    transform-origin: left center 0px;
    border-radius: 1px;
  }

  &:nth-child(1) {
    animation: ${frame0} 1s linear infinite;

    > div {
      transform: rotate(0deg) translate(4px, 0px);
    }
  }

  &:nth-child(2) {
    animation: ${frame1} 1s linear infinite;

    > div {
      transform: rotate(32deg) translate(4px, 0px);
    }
  }

  &:nth-child(3) {
    animation: ${frame2} 1s linear infinite;

    > div {
      transform: rotate(65deg) translate(4px, 0px);
    }
  }

  &:nth-child(4) {
    animation: ${frame3} 1s linear infinite;

    > div {
      transform: rotate(98deg) translate(4px, 0px);
    }
  }

  &:nth-child(5) {
    animation: ${frame4} 1s linear infinite;

    > div {
      transform: rotate(130deg) translate(4px, 0px);
    }
  }

  &:nth-child(6) {
    animation: ${frame5} 1s linear infinite;

    > div {
      transform: rotate(163deg) translate(4px, 0px);
    }
  }

  &:nth-child(7) {
    animation: ${frame6} 1s linear infinite;

    > div {
      transform: rotate(196deg) translate(4px, 0px);
    }
  }

  &:nth-child(8) {
    animation: ${frame7} 1s linear infinite;

    > div {
      transform: rotate(229deg) translate(4px, 0px);
    }
  }

  &:nth-child(9) {
    animation: ${frame8} 1s linear infinite;

    > div {
      transform: rotate(261deg) translate(4px, 0px);
    }
  }

  &:nth-child(10) {
    animation: ${frame9} 1s linear infinite;

    > div {
      transform: rotate(294deg) translate(4px, 0px);
    }
  }

  &:nth-child(11) {
    animation: ${frame10} 1s linear infinite;

    > div {
      transform: rotate(327deg) translate(4px, 0px);
    }
  }
`

type Props = {
  className?: string,
  hidden?: boolean,
}

const Spinner = ({ className, hidden = false }: Props): React.ReactElement => (
  <Wrapper className={className} hidden={hidden} role="progressbar">
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
    <SpinnerHand>
      <div></div>
    </SpinnerHand>
  </Wrapper>
)

export default Spinner
